import React, { memo } from 'react';
import _get from 'lodash/get';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Navbar from '../../components/navbar';
import SearchComponent from '../../components/search-component';
import Tracking from 'utils/tracking';

const Subnav = (props) => {

    const {
        topics,
        dictionary,
        itemsBasePath
    } = props;

    const dropdownLabel = _get(dictionary, 'more_channels_text');

    return (
        <Navbar
            items={topics}
            itemsBasePath={itemsBasePath}
            onSubNavItemClick={Tracking.onSubNavItemClick}
            onSubNavDropDownClick={Tracking.onSubNavDropDownClick}
            searchComponent={<SearchComponent />}
            dropdownLabel={dropdownLabel}
        />
    );

};

Subnav.propTypes = {
    topics: PropTypes.array,
    dictionary: PropTypes.object,
};

Subnav.defaultProps = {
    topics: [],
    dictionary: {},
};

export default memo(Subnav);
